import styled from 'styled-components';

import { VehicleChatPlaceholder } from '../../../assets';
import { ThemeProp } from '../../../theme/Themes';
import Button from '../../Button';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const SideContentContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const imgCommonProps = (props: ThemeProp) => {
  return `
  width: 4.25rem;
  height: 2.5rem;
  border-radius: ${props.theme.borderRadius};
  `;
};

export const VehicleImg = styled.img`
  ${(props: ThemeProp) => imgCommonProps(props)}
  background-color: lightgray; // NOTE: Spec from design system
  object-fit: cover;
`;

export const StyledVehicleChatPlaceholder = styled(VehicleChatPlaceholder)`
  ${(props: ThemeProp) => imgCommonProps(props)}
`;

export const VehicleInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TitleText = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.white};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
`;

export const VehicleStatus = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c200};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  line-height: 1rem;
`;

export const StyledButton = styled(Button)`
  height: 2rem;
`;

export const ActiveIndicator = styled.div`
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 0.375rem;
  background: ${(props: ThemeProp) => props.theme.colors.primary.c200};
`;

export const WatchingNowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;
